import { useSelector } from "react-redux";
import { useEffect } from "react";
import store from "../../store";
import { MENU_CONFIG } from "../../data/menu/MenuModule";
import { checkVisibility } from "../../logic/Menu/filterMenuPermissions";
import {
  selectUserData,
  selectUserMenuFiltered,
  setUserMenuFiltered,
} from "../../features/userSlice";
import Drawer from "../../components/MenuDrawer/Drawer";
import { useDeviceDetection } from "../../customHooks/useDeviceDetection";
import MobileDrawer from "../../components/MenuDrawer/MobileDrawer";

export function DrawerScreen() {
  const userMenuFiltered = useSelector(selectUserMenuFiltered);
  const userData = useSelector(selectUserData);
  const userDataPermissions = userData?.data?.products;
  const { deviceType } = useDeviceDetection();
  const isDesktop = deviceType === "desktop";

  useEffect(() => {
    const visibleMenu = checkVisibility(MENU_CONFIG, userDataPermissions);
    store.dispatch(setUserMenuFiltered(visibleMenu));
  }, [userDataPermissions]);

  // Return the appropriate drawer based on device
  if (isDesktop) {
    return userMenuFiltered?.length !== undefined ? <Drawer /> : null;
  } else {
    return userMenuFiltered?.length !== undefined ? <MobileDrawer /> : null;
  }
}
